export {
  COUNTRIES,
  DEFAULT_COUNTRY,
  getCountryByCode,
  getCountryByDialCode,
  getMinPhoneLength,
  getMaxPhoneLength,
  isValidPhoneLength,
} from './countries';

export type { Country } from './countries';

export {
  validatePhone,
  formatPhoneE164,
  formatPhoneWithPlus,
  validateE164,
  parseE164Phone,
  formatPhoneDisplay,
} from './validation';
